import { render } from "./RegraItem.vue?vue&type=template&id=ad8f867e&scoped=true"
import script from "./RegraItem.vue?vue&type=script&lang=js"
export * from "./RegraItem.vue?vue&type=script&lang=js"

import "./RegraItem.vue?vue&type=style&index=0&id=ad8f867e&lang=scss&scoped=true"

import exportComponent from "D:\\Projetos\\Git\\MINUS\\Sites\\site-gerencia\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad8f867e"]])

export default __exports__